// Must evaluate before every other import: module-scope i18n.t() calls
// freeze their strings when their module is first evaluated.
import "./shared/infrastructure/i18n/user-i18n";

import type React from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router/dom";
import { CoreModule } from "@/features/core/core.module";
import { AppThemeProvider } from "@frontend/shared/presentation/contexts/AppThemeProvider";
import { router } from "./router";

import "./shared/infrastructure/shared-features.config";

function App(): React.JSX.Element {
  return (
    <QueryClientProvider client={CoreModule.queryClient}>
      <AppThemeProvider>
        <RouterProvider router={router} />
      </AppThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
